import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function sitesListReducer(
  state = initialState.sitesList,
  action
) {
  switch (action.type) {
    case types.GET_SITES_LIST:
      return action.sitesList;
    default:
      return state;
  }
}
